module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    ref: "header",
    staticClass: "content-area header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.work.name) + "\n    \t")]), _vm._v(" "), _c('div', {
    staticClass: "note"
  }, [_c('span', [_c('i', [_vm._v("年级：")]), _vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.topShow),
      expression: "topShow"
    }],
    staticClass: "top"
  }, [_c('div', {
    staticClass: "top-left"
  }, [_c('div', [_vm._v(_vm._s(_vm.work.name))]), _vm._v(" "), _c('div', [_c('span', [_c('i', [_vm._v("年级：")]), _vm._v(_vm._s(_vm.convertGrade(_vm.work.gid)))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-right"
  }, [_c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.deleteWork
    }
  }, [_vm._v(" 删除当前作品")]), _vm._v(" "), _c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.updateWork
    }
  }, [_vm._v(" 修改当前作品")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-area"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品设计说明：")]), _vm._v(" "), _c('div', {}, [_c('p', [_vm._v(_vm._s(_vm.work.note))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品功能内容分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.audience))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品地形环境分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.env))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("作品针对面积分类："), _c('span', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.work.area))])]), _vm._v(" "), (_vm.work.spec != '') ? _c('div', {
    staticClass: "label"
  }, [_vm._v("作品任务书：")]) : _vm._e(), _vm._v(" "), (_vm.work.spec != '') ? _c('div', {
    staticClass: "work-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.work.spec
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.work.imgs_url.split(':').length > 0) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品图纸图片：")]), _vm._v(" "), _vm._l((_vm.work.imgs_url.split(':')[0].split(';')), function(imgSrc, index) {
    return _c('div', {
      key: index,
      staticClass: "work-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + imgSrc
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.work.imgs_url.split(':').length > 1) ? [_c('div', {
    staticClass: "label"
  }, [_vm._v("作品实体模型照片：")]), _vm._v(" "), _vm._l((_vm.work.imgs_url.split(':')[1].split(';')), function(imgSrc, index) {
    return _c('div', {
      key: index,
      staticClass: "work-img"
    }, [_c('img', {
      attrs: {
        "src": _vm.url + '/assets/upload/' + imgSrc
      }
    })])
  })] : _vm._e(), _vm._v(" "), (_vm.work.videos_url != '') ? _c('div', {
    staticClass: "label"
  }, [_vm._v("作品视频：")]) : _vm._e(), _vm._v(" "), (_vm.work.videos_url != '') ? _c('div', {
    staticClass: "work-video"
  }, [_c('div', {
    staticClass: "zhezhao"
  }), _vm._v(" "), _c('video', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.url + '/assets/upload/' + _vm.work.videos_url,
      "type": "video/mp4"
    }
  }), _vm._v("\n                当前浏览器不支持该视频格式\n         \t")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btn-section"
  }, [_c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.deleteWork
    }
  }, [_vm._v(" 删除当前作品")]), _vm._v(" "), _c('span', {
    staticClass: "button primary-btn",
    on: {
      "click": _vm.updateWork
    }
  }, [_vm._v(" 修改当前作品")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c82b314"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/WorkDetail.vue
// module id = 617
// module chunks = 1